'use strict';

angular.module('shiftTraderApp')
  .factory('Registration', function($http, ServerUrls, $q, Users) {

    return {
      createUserWithOrganization: function (hash) {
        return $http.post(ServerUrls.current.railsApi + 'registrations/organization', hash)
          .then(function(response) {
            return Users.initWithData(response.data);
          }, function (response) {
            return $q.reject(response);
          });
      },
      requestVerificationCode: function(data) {
        return $http.post(ServerUrls.current.railsApi + 'signup_token/', data)
          .then(function(response) {
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      }
    };
  });
